module.exports = __webpack_public_path__ + "img/组 308.d78acd5e.png";